var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gmap-marker',{attrs:{"position":{ lat: _vm.dealer.latitude, lng: _vm.dealer.longitude },"clickable":true,"title":_vm.dealer.name1,"icon":_vm.icon},on:{"click":_vm.clickMarker}})}
var staticRenderFns = []

export { render, staticRenderFns }